(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 7801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(8010);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "categoriesMapping": function() { return /* binding */ categoriesMapping; },
/* harmony export */   "default": function() { return /* binding */ BlogPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8109);
/* harmony import */ var _comps_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1083);
/* harmony import */ var _comps_meta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(624);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2213);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);









var blogJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
        {
            "@type": "ListItem",
            position: "0",
            name: "Home",
            item: "https://zoomerang.app/"
        },
        {
            "@type": "ListItem",
            position: "1",
            name: "Tools",
            item: "https://zoomerang.app/blog"
        }, 
    ]
};
var __N_SSP = true;
function BlogPage(props) {
    var posts = props.posts, pageIndex = props.pageIndex, maxPages = props.maxPages, current = props.current, featured = props.featured, categories = props.categories;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex h-screen flex-col justify-between",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_meta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: t("txt_blog_title"),
                        description: t("txt_blog_description"),
                        jsonLdData: [
                            blogJsonLd
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoryTabs, {
                        current: current,
                        categories: categories
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("w-full px-4 tablet:w-[728px] tablet:px-0 desktop:w-[1175px]", "mx-auto flex flex-col items-center gap-2 tablet:gap-3 desktop:gap-4"),
                        children: [
                            featured !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedPosts, {
                                posts: featured
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Posts, {
                                posts: posts
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageNumbers, {
                                page: pageIndex,
                                max: maxPages,
                                current: current
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_footer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
        ]
    });
}
function FeaturedPosts(props) {
    var posts = props.posts;
    var _posts = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(posts, 3), first = _posts[0], second = _posts[1], third = _posts[2];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative z-20 flex w-full flex-col gap-4 tablet:h-[466px] tablet:flex-row-reverse desktop:h-[542px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SinglePost, {
                post: first,
                topFeatured: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "inline-flex shrink-0 flex-col gap-4 tablet:gap-[18px] desktop:gap-[14px]",
                children: [
                    second && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SinglePost, {
                        post: second,
                        otherFeatured: true
                    }),
                    second && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SinglePost, {
                        post: third,
                        otherFeatured: true
                    })
                ]
            })
        ]
    });
}
function CategoryTabs(props) {
    var current = props.current, categories = props.categories;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("page-blog").t;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative z-10 flex flex-col items-center", "h-[300px] tablet:h-[410px] desktop:h-[576px]", "mb-[-150px] tablet:mb-[-170px] desktop:mb-[-320px]", "pt-4 tablet:pt-[60px] desktop:pt-[60px]", "gap-[22px] tablet:gap-[26px] desktop:gap-6"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/blog/index-background.webp"),
                alt: "background cover",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("absolute left-0 top-0 z-10 w-screen object-cover", "pointer-events-none", "-translate-y-1/3 dark:opacity-40")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-h1 relative z-20",
                children: t("txt_zoomerang_blog")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative z-20 flex justify-start gap-4 tablet:justify-center", "no-scrollbar w-full overflow-x-scroll px-4"),
                children: categories.map(function(category) {
                    var ref1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: category === "all" ? "/blog" : "/blog/".concat(category, "/1"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("text-[16px]", "rounded-full border", "px-[18px] py-[6px]", "select-none transition-colors duration-200 ease-in-out", current === category ? [
                                "bg-blue-900",
                                "text-blue-50",
                                "pointer-events-none",
                                "font-700", 
                            ] : [
                                "bg-[rgba(255,255,255,0.42)]",
                                "border-[rgba(255,255,255,0.62)]",
                                "dark:bg-[rgba(0,0,0,0.42)]",
                                "dark:border-[rgba(0,0,0,0.42)]",
                                "text-blue-900",
                                "hover:bg-color-background",
                                "font-600", 
                            ], "shrink-0"),
                            children: (ref = (ref1 = categoriesMapping.find(function(mapping) {
                                return mapping.value === category;
                            })) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref !== void 0 ? ref : category
                        })
                    }, category);
                })
            })
        ]
    });
}
var categoriesMapping = [
    {
        value: "all",
        name: "All"
    },
    {
        value: "templates",
        name: "Templates"
    },
    {
        value: "social-media",
        name: "Social Media"
    },
    {
        value: "app-editor",
        name: "App Editor"
    },
    {
        value: "trends",
        name: "Trends"
    },
    {
        value: "tutorials",
        name: "Tutorials"
    },
    {
        value: "editing-basics",
        name: "Editing Basics"
    },
    {
        value: "content-ideas",
        name: "Content Ideas"
    },
    {
        value: "ai-and-tools",
        name: "AI and Tools"
    },
    {
        value: "e-commerce",
        name: "E-commerce"
    },
    {
        value: "side-hustle",
        name: "Side Hustle"
    }, 
];
function PageNumbers(props) {
    var page = props.page, max = props.max, current = props.current;
    if (max === 1) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    var pages = getPageNumbers(page, max);
    var hideLeftArrow = page === 1;
    var hideRightArrow = page === max;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "z-20 inline-flex items-center gap-[22px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChangePageArrow, {
                direction: "left",
                page: page,
                current: current,
                hide: hideLeftArrow
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex select-none items-center gap-2 font-600",
                children: pages.map(function(pageIndex, index) {
                    if (pageIndex === null) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("h-[34px] w-[34px] rounded-full", "pointer-events-none", "flex items-center justify-center"),
                        children: "..."
                    }, index);
                    var pageAddress = current === "all" && pageIndex === 1 ? "/blog" : "/blog/".concat(current, "/").concat(pageIndex);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: pageAddress,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(page === pageIndex ? [
                                "pointer-events-none bg-primary-500 text-color-white", 
                            ] : "text-blue-900 hover:bg-blue-200", "flex items-center justify-center", "h-[34px] w-[34px] rounded-full", "transition-colors duration-200 ease-in-out"),
                            children: pageIndex
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChangePageArrow, {
                direction: "right",
                page: page,
                current: current,
                hide: hideRightArrow
            })
        ]
    });
}
function ChangePageArrow(props) {
    var page = props.page, current = props.current, direction = props.direction, hide = props.hide;
    var pageIndex = direction === "left" ? page - 1 : page + 1;
    var pageAddress = current === "all" && pageIndex === 1 ? "/blog" : "/blog/".concat(current, "/").concat(pageIndex);
    if (hide) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "h-[34px] w-[34px] shrink-0"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: pageAddress,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("bg-color-cell hover:bg-blue-100", "transition-colors duration-200 ease-in-out", "border border-color-separator", "h-[34px] w-[34px]", "rounded-full", "flex items-center justify-center", "drop-shadow-sm"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("[--icon-color:var(--color-blue-900)]", direction === "right" && "rotate-180"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Arrow, {})
            })
        })
    });
}
var Arrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "5",
        height: "8",
        viewBox: "0 0 5 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4.00415 7L1 4L4.00415 1",
            stroke: "var(--icon-color)",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
function closedInterval(start, end) {
    return new Array(end - start + 1).fill(0).map(function(_, i) {
        return start + i;
    });
}
var MAX_PAGE_NUMBERS = 5;
function getPageNumbers(page, max) {
    if (max < MAX_PAGE_NUMBERS) {
        return closedInterval(1, max);
    }
    if (page === 1) {
        return [
            1,
            2,
            null,
            max
        ];
    }
    if (page === 2) {
        return [
            1,
            2,
            3,
            null,
            max
        ];
    }
    if (page >= max - 2) {
        return [
            1,
            null,
            max - 2,
            max - 1,
            max
        ];
    }
    return [
        1,
        null,
        page,
        page + 1,
        null,
        max
    ];
}
function Posts(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("grid w-full grid-cols-2 gap-4 desktop:grid-cols-3 desktop:gap-[25px]", "relative z-20"),
        children: props.posts.map(function(post) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SinglePost, {
                post: post
            }, post.slug);
        })
    });
}
var blogCdn = "https://filesw.zoomerang.info/blog";
function SinglePost(props) {
    var post = props.post, topFeatured = props.topFeatured, otherFeatured = props.otherFeatured;
    var notFeatured = !topFeatured && !otherFeatured;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: "/blog/".concat(post.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: "group flex flex-1 shrink-0 select-none flex-col gap-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(topFeatured && [
                        "h-[284px] w-full tablet:h-full", 
                    ], otherFeatured && [
                        "h-[209px] tablet:h-[164px] tablet:w-[295px]",
                        "desktop:h-[200px] desktop:w-[374px]", 
                    ], notFeatured && [
                        "tablet:w-[356px]",
                        "desktop:h-[200px] desktop:w-[374px]", 
                    ], "relative overflow-hidden rounded-[12px] transition-all group-hover:rounded-[4px]"),
                    children: post.cover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("h-full w-full", "group-hover:scale-105", "transition-transform duration-200 ease-in-out", topFeatured ? " object-cover object-left-top" : "object-cover object-left-top"),
                        src: post.cover ? "".concat(blogCdn, "/").concat(post.cover) : "/images/placeholder.png",
                        alt: post.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("font-bold line-clamp-2 shrink-0 font-700 text-blue-700", topFeatured && "w-full", otherFeatured && "tablet:w-[295px] desktop:w-[374px]", topFeatured ? "h-14 text-lg" : "h-12 text-base"),
                    children: post.title
                })
            ]
        })
    }, post.slug);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(7801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);